<template>
  <div>
    <bread :list="list"></bread>
    <!--筛选 添加  -->
    <div class="flex align-center text-14 justify-start screenAdd">
        <el-form :label-position="labelPosition" class="demo-form-inline"  :inline="true" :model="formLabelAlign">
            <el-form-item >
                <el-input v-model="formLabelAlign.search_content"   placeholder="请输入姓名，电话，身份证号" @keyup.enter.native="titleChoose">
                    <el-button slot="append" icon="el-icon-search" @click="titleChoose"></el-button>
                </el-input>
            </el-form-item>
            <!-- <el-form-item size="large"  label="  " class="text-center ">
                <el-button class="btn1" type="primary" @click="sousuo">搜索</el-button>
            </el-form-item> -->
        </el-form>
    </div>
    <!-- 数据列表  -->
    <choicseList :dataList='dataList' @chidChoicseFun="contactsInfo"></choicseList>
    <img  v-if="nolist" class="nolist" :src="$no" alt="">
    <!-- 分页  -->
    <page @CurrentChangeFun='getCurrent' :pageMsg="pageMsg"></page>
    <!-- 弹框  -->
    <masks  :masksData="masksData" @childCloseClick="parCloseFun" @childSureClick='setContacts'></masks>
  </div>
</template>

<script>
import bread from "../../../components/bread";
import page from "../../../components/page";
import masks from "../../../components/mask";
import choicseList from "../components/choicse"; 
export default {
    components: {
        bread,
        page,
        choicseList,
        masks
    },
    data() {
        return {
            list: [
                {
                title: "信息管理"
                },
                {
                title: "添加联系人"
                },
            ],
            nolist:false,
            pageMsg:{},  //分页信息
            labelPosition:'right',
            formLabelAlign:{
                token:window.localStorage.getItem('pc_token'),
                limit:10,   //每页查询条数 默认是10条
                page:1,  //当前页数
                search_content:''
            },
            masksData:{    //弹框信息
                show:false,
                title:'设置联系人',
                info:[
                    {title:'姓名：',name:'user_name',value:'',palctHolder:'请输入手机号',isText:true,isDisabled:true},
                    {title:'手机号：',name:'user_phone',value:'',palctHolder:'请输入',isTel:true,isDisabled:true},
                    {title:'身份证号：',name:'idcard',value:'',palctHolder:'',isText:true,isDisabled:true},
                    {title:'职位：',name:'position',value:'',palctHolder:'请输入',isText:true,isDisabled:false,remind:'请输入职位'},
                    {title:'排序：',name:'sort',value:'',palctHolder:'请输入',isSort:true,tips:'数值越大越靠前',isDisabled:false,remind:'请选择排序'},
                    {name:'token',value:window.localStorage.getItem('pc_token'),hide:true,isDisabled:false},
                    {name:'u_id',value:'',hide:true,isDisabled:false},
                ],
                cancelText:'取消',
                sureText:'确定选择'
            },
             dataList:{   //数据列表
                isContact:true,
                list:[]
            },  
            isDisabled:true,
        };
    },
    created(){
        this.selectList(this.formLabelAlign);  // 选择联系人列表 
    },
    methods: {
        // 选择联系人列表
        selectList(data){
            this.post(this, "/home/selectList", data).then(res => {
                var data=res.data.data;
                this.dataList.list=data.data;
                if(this.dataList.list.length==0){
                    this.nolist=true;
                }
                this.pageMsg=data;
            });
        },
        // 点击分页
        getCurrent(val){
            this.formLabelAlign.page=val;
            this.selectList(this.formLabelAlign);
        },
        parCloseFun(msg){  //弹框取消 关闭
            this.masksData.show = !msg;
        },
         // 设置联系人接口
        setContacts(data){  //弹框确认
            var params={};
            if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled=false;
                for (var item of data){
                    if(!item.isDisabled){
                        if(item.value!==0){
                            if(!item.value||item.value.toString().trim() ==''){
                                this.$message.error(item.remind);
                                this.isDisabled=true;
                                return false;
                            }
                        }
                        params[item.name]=item.value;
                    }
                }
                this.post(this, "/home/setContacts", params).then(res => {
                    if(res.data.code == 0) {
                        this.$message.success(res.data.msg);
                        this.masksData.show = false;
                        this.formLabelAlign.page=1;   //刷新
                        this.selectList(this.formLabelAlign);
                        this.isDisabled=true;
                    } 
                });
            }
        },
        // 选择
        contactsInfo(u_id){  //点击编辑
            var data={
                token:window.localStorage.getItem('pc_token'),
                u_id
            }
            if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled=false;
                // 联系人信息接口
                this.post(this, "/home/contactsInfo", data).then(res => {
                    var data=res.data.data;
                    this.masksData.info[0].value=data.user_name;
                    this.masksData.info[1].value=data.user_phone;
                    this.masksData.info[2].value=data.idcard;
                    this.masksData.info[3].value='';
                    this.masksData.info[4].value='';
                    this.masksData.info[6].value=data.u_id;
                    this.masksData.show = true; 
                    this.isDisabled=true;
                });
            }
        },
        sousuo(){
            this.formLabelAlign.page=1;
            this.selectList(this.formLabelAlign);
        },
        // 搜索回车
        titleChoose(){
            this.formLabelAlign.page=1;
            this.selectList(this.formLabelAlign);
        },
    },
};
</script>
<style scoped>
.line1{
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
}
.line2{
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
.screenAdd{
    margin-top:45px;
}
select,
input[type='text'] {
    width: 218px;
    height: 33px;
    border: 1px solid #cccccc;
    padding: 0 6px;
}
.btnRi {
    color:#FF6633;
}
.btn1{
    width: 130px;
    border: none;
    background-color: #FF7C00;
    color: #fff;
}
.apply {
  height: 30px;
  line-height: 30px;
  width: 41px;
  background: #ff7b00;
}
</style>